import XLSX from 'xlsx';

export default {
  methods: {
    exportXLSExportTransferencias (exportTransferencias) {
      
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Export Transferencias",
        Subject: "ExportTransferencias",
        Author: "RegistrosPromocionales",
        CreatedDate: new Date()
      };
    
      let data = [
        [
          'Código',
          'Titular',
          'CUIT',
          'Email',
          'Banco',
          'CBU',
          'CBU Alias',
          // 'CVU',
          'Importe',
          // 'Estado',
          'Referencia',
          'Fecha Transferencia',
          'Importe Transferido',
          'Motivo Rechazo'
        ]
      ];

      if (exportTransferencias.renglones) {
        if (exportTransferencias.renglones.length != 0) {
          exportTransferencias.renglones.forEach(renglon => {
            data.push([
              renglon.id.toString().trim(),
              renglon.titularCuenta.trim(),
              renglon.titularCuit.trim(),
              renglon.email.trim(),
              renglon.banco.trim(),
              renglon.cbu.trim(),
              renglon.cbuAlias.trim(),
              // renglon.cvu.trim(),
              renglon.importe,
              exportTransferencias.evento.trim(),
              '',
              '',
              ''
            ]);
          });
        }
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "exportTransferencias");

      let xlsName = `export_transferencias.xlsx`; 
      XLSX.writeFile(wb, xlsName);

      return;
    },
    exportXLSExportTransferenciasPreview (evento, exportTransferencias, fileName) {
      
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Export Transferencias",
        Subject: "ExportTransferencias",
        Author: "RegistrosPromocionales",
        CreatedDate: new Date()
      };
    
      let columns = [];

      if ((/true/i).test(evento.solicitaCodigoPromocion)) {
        columns.push('Cod.Promoción');
      }
      if ((/true/i).test(evento.solicitaNombre)) {
        columns.push('Nombre');
      }
      if ((/true/i).test(evento.solicitaDocumento)) {
        columns.push('Nro.Documento');
      }
      if ((/true/i).test(evento.solicitaTelefono)) {
        columns.push('Nro.Celular');
      }
      if ((/true/i).test(evento.solicitaEmail)) {
        columns.push('Email');
      }
      if ((/true/i).test(evento.participacionNegocios)) {
        columns.push('Negocio');
        if ((/true/i).test(evento.solicitaRazonSocialNegocio)) {
          columns.push('Razón Social');
        }
        if ((/true/i).test(evento.solicitaDocumentoNegocio)) {
          columns.push('CUIT');
        }
      }
      columns.push('Banco');
      columns.push('CBU');
      columns.push('CBU Alias');
      columns.push('Fecha Autorizacion');
      columns.push('Importe Transferir');

      let data = [ [] ];
      data.push([ ...columns ]);

      if (exportTransferencias.length != 0) {
        exportTransferencias.forEach(transferencia => {
          let dataTransferencia = [];

          if ((/true/i).test(evento.solicitaCodigoPromocion)) {
            dataTransferencia.push(transferencia.codigoPromocion.trim());
          }
          if ((/true/i).test(evento.solicitaNombre)) {
            dataTransferencia.push(transferencia.nombreCompleto.trim());
          }
          if ((/true/i).test(evento.solicitaDocumento)) {
            dataTransferencia.push(transferencia.documentoNumero.trim());
          }
          if ((/true/i).test(evento.solicitaTelefono)) {
            dataTransferencia.push(transferencia.numeroCelular.trim());
          }
          if ((/true/i).test(evento.solicitaEmail)) {
            dataTransferencia.push(transferencia.email.trim());
          }
          if ((/true/i).test(evento.participacionNegocios)) {
            dataTransferencia.push(transferencia.negocio.trim());
            if ((/true/i).test(evento.solicitaRazonSocialNegocio)) {
              dataTransferencia.push(transferencia.razonSocial.trim());
            }
            if ((/true/i).test(evento.solicitaDocumentoNegocio)) {
              dataTransferencia.push(participante.negocioCuit.trim());
            }
          }
          dataTransferencia.push(transferencia.banco.trim());
          dataTransferencia.push(transferencia.cbu.trim());
          dataTransferencia.push(transferencia.cbuAlias.trim());
          dataTransferencia.push(this.$options.filters.fecha(transferencia.fechaAutorizacion));
          dataTransferencia.push(transferencia.importe);

          data.push([ ...dataTransferencia ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "exportTransferencias");

      let xlsName = `${fileName}.xlsx`; 
      XLSX.writeFile(wb, xlsName);

      return;
    },    
    exportXLSExportTransferenciasList (evento, exportTransferencias, fileName) {
      
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Export Transferencias",
        Subject: "ExportTransferencias",
        Author: "RegistrosPromocionales",
        CreatedDate: new Date()
      };
    
      let columns = [];

      if ((/true/i).test(evento.solicitaCodigoPromocion)) {
        columns.push('Cod.Promoción');
      }
      if ((/true/i).test(evento.solicitaNombre)) {
        columns.push('Nombre');
      }
      if ((/true/i).test(evento.solicitaDocumento)) {
        columns.push('Nro.Documento');
      }
      if ((/true/i).test(evento.solicitaTelefono)) {
        columns.push('Nro.Celular');
      }
      if ((/true/i).test(evento.solicitaEmail)) {
        columns.push('Email');
      }
      if ((/true/i).test(evento.participacionNegocios)) {
        columns.push('Negocio');
        if ((/true/i).test(evento.solicitaRazonSocialNegocio)) {
          columns.push('Razón Social');
        }
        if ((/true/i).test(evento.solicitaDocumentoNegocio)) {
          columns.push('CUIT');
        }
      }
      columns.push('Banco');
      columns.push('CBU');
      columns.push('CBU Alias');
      columns.push('Fecha Autorizacion');
      columns.push('Importe Transferir');
      /* Datos de la transferencia completada/rechazada */
      columns.push('Fecha Transferencia');
      columns.push('Importe Transferido');
      columns.push('Estado');
      columns.push('Observaciones');

      let data = [ [] ];
      data.push([ ...columns ]);

      if (exportTransferencias.length != 0) {
        exportTransferencias.forEach(transferencia => {
          let dataTransferencia = [];

          if ((/true/i).test(evento.solicitaCodigoPromocion)) {
            dataTransferencia.push(transferencia.codigoPromocion.trim());
          }
          if ((/true/i).test(evento.solicitaNombre)) {
            dataTransferencia.push(transferencia.nombreCompleto.trim());
          }
          if ((/true/i).test(evento.solicitaDocumento)) {
            dataTransferencia.push(transferencia.documentoNumero.trim());
          }
          if ((/true/i).test(evento.solicitaTelefono)) {
            dataTransferencia.push(transferencia.numeroCelular.trim());
          }
          if ((/true/i).test(evento.solicitaEmail)) {
            dataTransferencia.push(transferencia.email.trim());
          }
          if ((/true/i).test(evento.participacionNegocios)) {
            dataTransferencia.push(transferencia.negocio.trim());
            if ((/true/i).test(evento.solicitaRazonSocialNegocio)) {
              dataTransferencia.push(transferencia.razonSocial.trim());
            }
            if ((/true/i).test(evento.solicitaDocumentoNegocio)) {
              dataTransferencia.push(participante.negocioCuit.trim());
            }
          }
          dataTransferencia.push(transferencia.banco.trim());
          dataTransferencia.push(transferencia.cbu.trim());
          dataTransferencia.push(transferencia.cbuAlias.trim());
          dataTransferencia.push(this.$options.filters.fecha(transferencia.fechaAutorizacion));
          dataTransferencia.push(transferencia.importe);

          if ((/true/i).test(transferencia.completada) || (/true/i).test(transferencia.rechazada)) {
            dataTransferencia.push(this.$options.filters.fecha(transferencia.fechaTransferencia));
            dataTransferencia.push(transferencia.importeTransferido);
          } else {
            dataTransferencia.push('');
            dataTransferencia.push('');
          }
          dataTransferencia.push(transferencia.estado.trim());
          dataTransferencia.push(transferencia.motivoRechazo.trim());

          data.push([ ...dataTransferencia ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "exportTransferencias");

      let xlsName = `${fileName}.xlsx`; 
      XLSX.writeFile(wb, xlsName);

      return;
    },    

  }
}
